import React, { useState, useEffect } from "react";
import Tabs from "../../../Component/DigitalMarketing/Tabs";
import { PasswordLabel, SettingsTabs, UserPasswordLabel, ivfSettingsTabs } from "./Utils";
import { useDispatch, useSelector } from "react-redux";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import HospitalProfile from "./HospitalProfile";
import PasswordUpdate from "./PasswordUpdate";
import UserProfileUpdate from "./UserProfileUpdate";
import { Col, Row } from "react-bootstrap";
import Toast from "../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Template from "./Template";
import UserPasswordChange from "./UserPasswordChange";

function Settings() {
  const [active, setActive] = useState(1);
  const account = useSelector((state: any) => state.auth);
  const {roleName} = account
  console.log(roleName)
  const dispatch = useDispatch();
  const { open, message, openSnackBar, type } = useSnackbar();

  useEffect(() => {
    const data: any = {
      first: "Settings",
    };
    dispatch(Change(data));
    // dispatch(Reset());
    // dispatch(GetBranchList());
  }, [dispatch]);
  return (
    <React.Fragment>
      <Toast open={open} type={type} message={message} />
       <Tabs tablist={roleName==='super_admin' ?ivfSettingsTabs.filter((tab)=>tab.name!=='Password Change') : ivfSettingsTabs} setActive={setActive} active={active} />
      {/* <Tabs tablist={SettingsTabs} setActive={setActive} active={active} /> */}
      <Row>
        <Col md={9}>
          <div className="cards mt-3">
            {active === 1 && <HospitalProfile />}
            {/* {active === 2 && <UserProfileUpdate openSnackBar={openSnackBar}/>} */}

            {active === 3 &&   <PasswordUpdate form={PasswordLabel} />}
            {active === 4 && <Template openSnackBar={openSnackBar} />}
            {active === 5 && <UserPasswordChange  form={UserPasswordLabel}/>}

          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default Settings;
